import { Const } from '~/constants/Const.constant';
import { battery, lastData, lastSeen } from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class Thermostat extends NAModule {

    MAX_TIME_BEFORE_UNKNOWN = 2 * 3600;

    battery_levels = {
        full :            Const.NABatteryLevelThermostat.THERMOSTAT_BATTERY_LEVEL_0,
        high :            Const.NABatteryLevelThermostat.THERMOSTAT_BATTERY_LEVEL_1,
        medium :          Const.NABatteryLevelThermostat.THERMOSTAT_BATTERY_LEVEL_2,
        low :             Const.NABatteryLevelThermostat.THERMOSTAT_BATTERY_LEVEL_3,
    };

    isWired = true;
    rf_status?: number;
    manual_pairing?: string;
    hasOperationDissociate = false;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf_status), this.rf_status);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldLastData() {
        return lastData(this.last_data, this.outdatedLastData ? 'error--text' : '');
    }
}
